import React, { useState } from "react";
import { Link } from "react-router-dom";
import AboutMe from "./AboutMe";
const Home = () => {
  const [aboutMe, setAboutMe] = useState(false);
  return (
    <div className="home-container">
     
      <div>
        <h1> Oh, hello there.</h1>
      </div>
      <section className="under-head-contain">
        <Link className="txt-dec" to="/projects">
          <h4 className="link-under-head">Projects</h4>
        </Link>
        <h4 id="learn-about-me" onClick={() => setAboutMe(!aboutMe)}>
          Learn About Me
        </h4>
      </section>
      <div className={aboutMe ? "about-me-on" : "about-me-off"}>
        <AboutMe />
      </div>
    </div>
  );
};

export default Home;
